import { useEffect } from "react";

let openLocks = 0;
let overflowBeforeLock = "";

/**
 * Stops the page under an overlay from scrolling. Counted, so a screen opened over another
 * (dates over Confirm and pay) never unlocks the page while the one below is still open.
 */
export function useLockBodyScroll(active = true): void {
  useEffect(() => {
    if (!active) return;
    if (openLocks === 0) {
      overflowBeforeLock = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    openLocks += 1;
    return () => {
      openLocks -= 1;
      if (openLocks === 0) document.body.style.overflow = overflowBeforeLock;
    };
  }, [active]);
}
